import { create } from 'zustand';

interface RemoveDraftModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useRemoveDraftModal = create<RemoveDraftModalStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useRemoveDraftModal;
